enum PreferenceGroup {
  TAFSIRS = 'tafsirs',
  TRANSLATIONS = 'translations',
  AUDIO = 'audio',
  THEME = 'theme',
  QURAN_READER_STYLES = 'quranReaderStyles',
  READING = 'reading',
  LANGUAGE = 'language',
}
export default PreferenceGroup;
